// WS-33712: Currently running an A/B test of an interstitial to see if it helps fundraising.
import { LightBoxWrapper } from '../LightBoxWrapper';
import InterstitialPopup from './InterstitialPopup';

import { createPortal } from 'react-dom';

interface FacebookShareInterstitialType {
    facebookLink: string,
    show: boolean,
    hide: () => null
}

export const FacebookShareInterstitial = ({
    show, hide, facebookLink,
}:FacebookShareInterstitialType) => {
    const container = document.getElementById('mainBody')!;
    return (show && createPortal(<LightBoxWrapper fixed={true} unMountHandler={hide}>
        <InterstitialPopup link={facebookLink} />
    </LightBoxWrapper>, container));
};
